import { DEFAULT_CURRENCY_SIGN, FORMAT_LOCALE } from '@/constants/common';
import { KB, MB, GB, TB } from '@/constants/files';

const DEFAULT_FRACTION_DIGITS = 2;

export const getFileExtension = (fileName?: string): string => fileName?.split('.').pop()?.toLowerCase() ?? '';

export function formatBytes(bytes: number) {
    let value: number;
    let suffix: string;

    if (bytes < KB) {
        return `${bytes} B`;
    } else if (bytes < MB) {
        value = bytes / KB;
        suffix = 'KB';
    } else if (bytes < GB) {
        value = bytes / MB;
        suffix = 'MB';
    } else if (bytes < TB) {
        value = bytes / GB;
        suffix = 'GB';
    } else {
        value = bytes / TB;
        suffix = 'TB';
    }

    const rounded = Math.round(value * 10) / 10;
    const roundedStr = (Math.round(rounded) === rounded ? Math.round(rounded) : rounded).toString();

    return `${roundedStr} ${suffix}`;
}

export const formatPageTitle = (layoutTitle: string, pageTitle?: string) =>
    pageTitle ? `${layoutTitle} - ${pageTitle}` : layoutTitle;

export const formatCurrency = (n: number, fractionDigits = DEFAULT_FRACTION_DIGITS): string =>
    n.toLocaleString(FORMAT_LOCALE, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
    });

export const formatCurrencySigned = (
    n: number,
    sign: string = DEFAULT_CURRENCY_SIGN,
    fractionDigits = DEFAULT_FRACTION_DIGITS
) => `${sign}${formatCurrency(n, fractionDigits)}`;

export const formatTokenBalance = (n: number): string =>
    n > 0 && n < 1
        ? n.toLocaleString(FORMAT_LOCALE, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 4
          })
        : n.toLocaleString(FORMAT_LOCALE, {
              minimumFractionDigits: DEFAULT_FRACTION_DIGITS,
              maximumFractionDigits: DEFAULT_FRACTION_DIGITS
          });
